module.exports = __webpack_public_path__ + "img/policyFace.701d077.jpg";